import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static values = {
		debounce: { type: Number, default: 500 }
	};

	static targets = ["input"];

	connect() {
		this.timeout = null;
	}

	handleInput() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.submitForm();
		}, this.debounceValue);
	}

	submitForm() {
		// Find the nearest form element and submit it.
		const form = this.element.closest('form');
		if (form) {
			// Using requestSubmit() allows for built-in form validation.
			form.requestSubmit();
		}
	}
}
